// --> actions do player <--
export const SUBMIT_LOGIN = 'SUBMIT_LOGIN';

// --> actions do game <--
export const INCREMENT_SCORE = 'INCREMENT_SCORE';
export const INCREMENT_QUEST = 'INCREMENT_QUEST';
export const ASSERTIONS = 'ASSERTIONS';
export const SAVE_SCORE = 'SAVE_SCORE';
export const SAVE_RANKING = 'SAVE_RANKING';
